module.exports = __webpack_public_path__ + "static/media/pic19-min.a73cb078.jpg";